export function getFullYear() {
    return (new Date).getFullYear()
}